import React, { useContext, useEffect, useState } from "react";
import MainContext from "../../MainContext";
import MySideBar from "../component/MySideBar";
import css from "../content.module.css";
import ContentViewer from "../ContentViewer";
export default function PricePage() {
  const ctx = useContext(MainContext);
  useEffect(() => {
    ctx.getDataProduct();
  }, []);

  return (
    <ContentViewer
      title={ctx.state.dataProduct?.title}
      imgdata={ctx.state.dataProduct?.imgdata}
      content={ctx.state.dataProduct?.content}
    />
  );
}
